import { FormEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { AuthCard } from '../../components/AuthCard';
import { Button } from '../../components/Button';
import { Input } from '../../components/Input';
import { loginMaster } from '../../api/master';
import { useMasterAuth } from '../../context/MasterAuthContext';

export function MasterLogin() {
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [enviando, setEnviando] = useState(false);
  const { setMaster } = useMasterAuth();
  const navigate = useNavigate();

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();
    setEnviando(true);

    try {
      const master = await loginMaster(email, senha);
      setMaster(master);
      navigate('/master');
    } catch (error: any) {
      Swal.fire({
        icon: 'error',
        title: 'Não foi possível entrar',
        text: error.response?.data?.erro || 'Verifique suas credenciais.',
      });
    } finally {
      setEnviando(false);
    }
  }

  return (
    <AuthCard titulo="Acesso mestre">
      <form onSubmit={handleSubmit}>
        <Input label="E-mail" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
        <Input label="Senha" type="password" value={senha} onChange={(e) => setSenha(e.target.value)} required />
        <Button type="submit" disabled={enviando}>
          {enviando ? 'Entrando...' : 'Entrar'}
        </Button>
      </form>
    </AuthCard>
  );
}
